import { Button, Modal } from "react-bootstrap";
import {
  generateForm,
  generateInitValues,
  generateValidationSchema,
} from "../../../../utils/AppFunction";
import React, { Dispatch, SetStateAction, useContext, useEffect, useState } from "react";
import { AppContext } from "../../../../appContext/AppContext";
import { XayDungKeHoachContext } from "../DanhSachKeHoach";
import { Formik, Form } from "formik";
import { CODE, DEFAULT_PAGE_INDEX, MAX_PAGE_SIZE, TYPE_WH, WF_TRACKER } from "../../../../utils/Constant";
import { toast } from "react-toastify";
import WfButton from "../../../../workflows/components/WfButton";
import { IconButtonSave } from "../../../../component/IconSvg";
import { formatDateDTO } from "../../../../utils/FormatUtils";
import { TypeKeHoach } from "../models/KeHoachModel";
import ModelHeader from "../../../../component/ModelHeader";
import DynamicComponent from "../../../../component/GenerateDynamicComponent";
import GenerateFormComponent from "../../../../component/generate-form/GenerateFormHTMLNoValid";
import CustomTabMenu from "../../../../component/CustomTabMenu";
import { TYPE_KE_HOACH_DAO_TAO, OPTION_KHAO_SAT } from "../constants/constansKeHoach";
import { EnterReasonDialog } from "../../../../component/EnterReasonDialog";
import { cancelApproval } from "../../../../phan-he-xuat-kho/services/servicesXuatKho";
import AutocompleteObjectV2 from "../../../../component/AutocompleteObjectV2";
import {
  addPhieuKhaoSat, getConfirmationStatuses,
  getProfessionalSupportCapabilities,
  getSupportStaffProposals,
  updatePhieuKhaoSat
} from "../services/services";
import { getDsThuocNhapKho } from "../../../../phan-he-nhap-kho/services/services";
import { CODE_KE_HOACH } from "../../../../quan-ly-ke-hoach/Components/danh-sach-ke-hoach/constants/constansKeHoach";
import TableDangKyDaoTao from "./TableDangKyDaoTao";
import DialogThemMoiDaoTao from "./DialogThemMoiDaoTao";
import { STATUS } from "../../../const/QuanLyCDT";

interface Props {
  show: boolean;
  onHide: () => void;
  initialValues: any;
  setInitialValues: Dispatch<SetStateAction<any>>
  warehouseId?: any;
  typeKH: TypeKeHoach;
}

const DialogPhieuKhaoSat = (props: Props) => {
  const { show, onHide, warehouseId, setInitialValues, initialValues, typeKH } = props;
  const { setIsLoading } = useContext(AppContext);
  const { detailPhieuKeHoach, setDetailPhieuKeHoach } = useContext(XayDungKeHoachContext);
  const [isView, setIsView] = useState<boolean>(detailPhieuKeHoach?.isView);
  const [listJsonGenerate, setListJsonGenerate] = useState<any>([]);
  const [initialValuesFormThemVT, setInitialValuesFormThemVT] = useState<any>({});
  const [indexRowEdit, setIndexRowEdit] = useState<number | null>(null);
  const [itemSelected, setItemSelected] = useState<any>();
  const [openDialogThemMoi, setOpenDialogThemMoi] = useState<boolean>(false);
  const [dataTable, setDataTable] = useState<any>({});
  const [typeDialogAddNew, setTypeDialogAddNew] = useState<any>(null);
  const [type, setType] = useState<TypeKeHoach>(typeKH);
  const [fieldReadOnly, setFieldReadOnly] = useState<any>(null);
  const handleFormSubmit = async (values: any) => {
    const dataSubmit = {
      slipDto: {
        ...values.khaoSat,
        type: type?.type,
        doCreation: values?.khaoSat?.id ? formatDateDTO(values?.khaoSat?.doCreation) : formatDateDTO(new Date()),
      },
      ...dataTable,
      trackerCode: type?.trackerCode,
      termModelType: type?.formThongTinChung,
    };

    try {
      setIsLoading(true);
      const id = values?.khaoSat?.id;
      const { data } = id ? await updatePhieuKhaoSat(id, dataSubmit) : await addPhieuKhaoSat(dataSubmit);

      if (CODE.SUCCESS === data?.code) {
        // setIsView(true);
        setInitialValues && setInitialValues(data?.data);
        // setDetailPhieuKeHoach({
        //   ...data?.data,
        //   statusId: detailPhieuKeHoach.statusId,
        // });
        toast.success(((id) ? "Cập nhật" : "Thêm") + " phiếu thành công");
      } else {
        let errorMesage = data?.data?.[0]?.message || "Xảy ra lỗi, vui lòng thử lại!";
        toast.warning(errorMesage);
      }
    } catch (error) {
      setIsLoading(false);
      toast.warning("Xảy ra lỗi, vui lòng thử lại!");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const getCustomViewField = () => {
    if (isView) return;
    if (detailPhieuKeHoach?.status && detailPhieuKeHoach?.status !== 'news_save') {
      setFieldReadOnly({
        name: true,
        responsiblePerson: true,
        startDate: true,
        endDate: true,
        plannedBedCount: false,
        actualBedCount: false,
        doctorCount: false,
        nurseCount: false,
        conclusion: false,

        // Hỗ trợ kỹ thuật chuyên môn
        generalHospitalMembersOpinions: true,
        proposedHospitalMembersOpinions: true,
      })
    } else {
      setFieldReadOnly({
        name: false,
        responsiblePerson: false,
        startDate: false,
        endDate: false,
        plannedBedCount: true,
        actualBedCount: true,
        doctorCount: true,
        nurseCount: true,
        conclusion: true,

        // Hỗ trợ kỹ thuật chuyên môn
        generalHospitalMembersOpinions: false,
        proposedHospitalMembersOpinions: false,
      })
    }
  }

  const handleChangeType = (option: any) => {
    setType(option);
    setInitialValues(initialValues)
  }

  const getSelectedRowsData = async (id: string) => {
    if (initialValues?.khaoSat?.type) {
      const itemType = OPTION_KHAO_SAT.find((x: any) => x?.type === initialValues?.khaoSat?.type) ?? OPTION_KHAO_SAT[0]
      setType(itemType)
    }
    if (type?.code === OPTION_KHAO_SAT[1]?.code) {
      try {
        const dataSp = await getSupportStaffProposals(id);
        const dataProSp = await getProfessionalSupportCapabilities(id);
        const dataConfirm = await getConfirmationStatuses(id);

        setDataTable({
          [TYPE_KE_HOACH_DAO_TAO.CAN_BO.code]: dataSp?.data?.data ?? [],
          [TYPE_KE_HOACH_DAO_TAO.KT_CHUYEN_MON.code]: dataProSp?.data?.data ?? [],
          [TYPE_KE_HOACH_DAO_TAO.NHU_CAU.code]: dataConfirm?.data?.data ?? [],
        })
      } catch (e) {

      }
    }
  };

  useEffect(() => {
    getCustomViewField()
  }, [detailPhieuKeHoach?.status]);

  useEffect(() => {
    initialValues?.id && getSelectedRowsData(initialValues?.id || detailPhieuKeHoach?.id);
  }, []);

  useEffect(() => {
    updateForm();
  }, [type]);

  const updateForm = async () => {
    if (!type?.formThongTinChung) return;
    const data = await generateForm(type?.formThongTinChung, setIsLoading);
    setListJsonGenerate(data || []);
    setInitialValues({
      ...generateInitValues(data),
      ...initialValues ?? {},
      doCreation: initialValues?.id ? formatDateDTO(initialValues?.doCreation) : formatDateDTO(new Date()),
    });
  };

  const handler = (data: any) => {
    setInitialValuesFormThemVT({
      ...initialValuesFormThemVT,
      ...data,
      isFirstChange: true,
    });
  };

  const handleEdit = (rowData: any, index: number, typeDialog: any) => {
    setTypeDialogAddNew(typeDialog)
    setItemSelected(rowData);
    setIndexRowEdit(index);
    setOpenDialogThemMoi(true)
  }

  const hanldeDeleteRow = (index: number, typeDelete: any) => {
    const key = typeDelete?.code;
    const list = dataTable?.[key] || [];

    const newList = list.filter((x: any, i: number) => i !== index);
    setDataTable((pre: any) => ({ ...pre, [key]: newList }));
  }

  const handleAddItem = async (values: any, source?: string) => {
    const key = typeDialogAddNew?.code;
    const item = values?.[key] || {};
    const list = dataTable?.[key] || [];

    const newList =
      indexRowEdit === null
        ? [{ ...item }, ...list]
        : list.map((x: any, i: number) => (i === indexRowEdit ? { ...item } : x));

    if (source) {
      setDataTable((pre: any) => ({ ...pre, [key]: newList }));
    }
  };

  const handleDeleteListItem = (data: any, typeDelete: any) => {
    const key = typeDelete?.code;
    const list = dataTable?.[key] || [];

    const newList = list.filter((x: any, i: number) => (data.find((y: any) => y?.id === x?.id)));
    setDataTable((pre: any) => ({ ...pre, [key]: newList }));
  };

  const handleCloseDialog = () => {
    setItemSelected(null);
    setIndexRowEdit(null);
    setOpenDialogThemMoi(false);
    setTypeDialogAddNew(null)
  };


  const handleApproveReq = async (values?: any) => { // nhập lý do từ chối duyệt
    try {
      setIsLoading(true);
      const { data } = await cancelApproval(values, initialValues.id);
      if (CODE.SUCCESS === data.code) {
        detailPhieuKeHoach.submit && detailPhieuKeHoach.submit();
        handleCloseDialog();
      } else {
        toast.error('Có lỗi xảy ra, vui lòng thử lại')
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpenDialogThemMoi = (type: any) => {
    setTypeDialogAddNew(type)
    setOpenDialogThemMoi(true);
  }
  const columnsCanBo = [
    {
      name: "STT",
      field: "",
      headerStyle: {
        width: 80,
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any, index: number, stt: number) => stt,
    },
    ...((!initialValues?.id && !isView) ?
      [
        {
          name: "Thao tác",
          field: "",
          headerStyle: {
            width: 80,
          },
          cellStyle: {
            textAlign: "center",
            justifyContent: "center"
          },
          render: (row: any, index: number, stt: number) =>
            <div className="d-flex justify-content-center">
              {indexRowEdit !== index && <>
                <i
                  onClick={(e) => handleEdit(row, index, TYPE_KE_HOACH_DAO_TAO.CAN_BO)}
                  className="bi bi-pencil-square text-navy"
                ></i>
                <i
                  onClick={(e) => hanldeDeleteRow(index, TYPE_KE_HOACH_DAO_TAO.CAN_BO)}
                  className="bi bi-trash3-fill text-danger spaces ml-10  "
                ></i>
              </>}
            </div>
        },
      ] : []),

    {
      name: "Chuyên khoa",
      field: "specialtyName",
      headerStyle: {},
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any, index: number, stt: number) => row.specialtyName || row.item?.specialtyName || '',
    },
    {
      name: "Số lượng người cử đi",
      field: "participantCount",
      headerStyle: {
        width: 200,
      },
      cellStyle: {
        textAlign: "right",
      },
      render: (row: any, index: number, stt: number) => row.participantCount || row.item?.participantCount || '',
    },
    {
      name: "Thời gian hỗ trợ (số ngày)",
      field: "supportDurationDays",
      headerStyle: {
        width: 220,
      },
      cellStyle: {
        textAlign: "right",
        padding: '0.75rem'
      },
      render: (row: any, index: number, stt: number) => row.supportDurationDays || row.item?.supportDurationDays || '',
    },
  ];
  const columnsKTChuyenMon = [
    {
      name: "STT",
      field: "",
      headerStyle: {
        width: 80,
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any, index: number, stt: number) => stt,
    },
    ...((!isView && initialValues?.id && detailPhieuKeHoach?.status === STATUS.new_save) ?
      [
        {
          name: "Thao tác",
          field: "",
          headerStyle: {
            width: 80,
          },
          cellStyle: {
            textAlign: "center",
            justifyContent: "center"
          },
          render: (row: any, index: number, stt: number) =>
            <div className="d-flex justify-content-center">
              {indexRowEdit !== index && <>
                <i
                  onClick={(e) => handleEdit(row, index, TYPE_KE_HOACH_DAO_TAO.KT_CHUYEN_MON)}
                  className="bi bi-pencil-square text-navy"
                ></i>
                <i
                  onClick={(e) => hanldeDeleteRow(index, TYPE_KE_HOACH_DAO_TAO.KT_CHUYEN_MON)}
                  className="bi bi-trash3-fill text-danger spaces ml-10  "
                ></i>
              </>}
            </div>
        },
      ] : []),

    {
      name: "Chuyên khoa",
      field: "specialtyName",
      headerStyle: {},
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any, index: number, stt: number) => row.specialtyName || row.item?.specialtyName || '',
    },
    {
      name: "Số lượng người cử đi",
      field: "participantCount",
      headerStyle: {
        width: 200,
      },
      cellStyle: {
        textAlign: "right",
      },
      render: (row: any, index: number, stt: number) => row.participantCount || row.item?.participantCount || '',
    },
    {
      name: "Thời gian hỗ trợ (số ngày)",
      field: "supportDurationDays",
      headerStyle: {
        width: 220,
      },
      cellStyle: {
        textAlign: "right",
        padding: '0.75rem'
      },
      render: (row: any, index: number, stt: number) => row.supportDurationDays || row.item?.supportDurationDays || '',
    },
  ];
  const columnsNhuCau = [
    {
      name: "STT",
      field: "",
      headerStyle: {
        width: 80,
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any, index: number, stt: number) => stt,
    },
    ...((!isView && initialValues?.id && detailPhieuKeHoach?.status !== STATUS.new_save) ?
      [
        {
          name: "Thao tác",
          field: "",
          headerStyle: {
            width: 80,
          },
          cellStyle: {
            textAlign: "center",
            justifyContent: "center"
          },
          render: (row: any, index: number, stt: number) =>
            <div className="d-flex justify-content-center">
              {indexRowEdit !== index && <>
                <i
                  onClick={(e) => handleEdit(row, index, TYPE_KE_HOACH_DAO_TAO.NHU_CAU)}
                  className="bi bi-pencil-square text-navy"
                ></i>
                <i
                  onClick={(e) => hanldeDeleteRow(index, TYPE_KE_HOACH_DAO_TAO.NHU_CAU)}
                  className="bi bi-trash3-fill text-danger spaces ml-10  "
                ></i>
              </>}
            </div>
        },
      ] : []),

    {
      name: "Tên kỹ thuật",
      field: "techniqueNameName",
      headerStyle: {
        minWidth: 200,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any, index: number, stt: number) => row.techniqueNameName || row.item?.techniqueNameName || '',
    },
    {
      name: "Thời gian hỗ trợ",
      field: "plannedSupportTime",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any, index: number, stt: number) => row.plannedSupportTime || row.item?.plannedSupportTime || '',
    },
    {
      name: "Địa điểm",
      field: "location",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any, index: number, stt: number) => row.location || row.item?.location || '',
    },
    {
      name: "Số buổi",
      field: "sessionCount",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any, index: number, stt: number) => row.sessionCount || row.item?.sessionCount || '',
    },
    {
      name: "Kinh phí",
      field: "budget",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "right",
        paddingRight: "8px",
      },
      render: (row: any, index: number, stt: number) => row.budget || row.item?.budget || '',
    },
  ];
  return (
    <Modal
      centered
      show={show}
      // onHide={onHide}
      size="xl"
      fullscreen
      className="page-full spaces h-calc-vh-50 dialog-phieu-khao-sat"
    >
      <Formik
        enableReinitialize
        validateOnChange={true}
        validateOnBlur={true}
        initialValues={{ khaoSat: initialValues }}
        validationSchema={generateValidationSchema(listJsonGenerate, 'khaoSat')}
        onSubmit={handleFormSubmit}
      >
        {({ values, touched, errors, setValues, handleChange, handleSubmit, setFieldValue }) => (
          <>
            <Form onSubmit={handleSubmit}>
              <ModelHeader onHide={onHide} title={`${values?.khaoSat?.id ? 'Cập nhật' : 'Thêm mới'} phiếu khảo sát`} />
              <Modal.Body className="spaces p-0 bg-white">
                <div className="spaces px-10">
                  <h4 className="title spaces mb-5 pt-10">Loại khảo sát</h4>
                  <div className="d-flex">
                    <AutocompleteObjectV2
                      options={OPTION_KHAO_SAT}
                      isSearchDefauilt={true}
                      name={"type"}
                      value={type}
                      isClearable={false}
                      onChange={handleChangeType}
                      disabled={isView || initialValues?.id}
                      className="autocomplete-custom-renderform radius spaces min-w-200 h-29"
                    />
                  </div>
                  <div className="spaces fw-bold">
                    <hr />
                  </div>
                </div>
                <div className="spaces px-10">
                  <GenerateFormComponent
                    isView={isView}
                    listFieldAuto={listJsonGenerate}
                    handleChange={handleChange}
                    setValues={setValues}
                    values={values}
                    touched={touched}
                    errors={errors}
                    propsRenderButton={handler}
                    setFieldValue={setFieldValue}
                    modelID={'khaoSat'}
                    customComponent={DynamicComponent}
                    warehouseId={warehouseId}
                    customFieldReadOnly={fieldReadOnly}
                  />
                  {type.code === CODE_KE_HOACH.KHHT && (
                    <>
                      <TableDangKyDaoTao
                        columns={columnsCanBo}
                        title={"Đề xuất cử người hỗ trợ"}
                        isView={initialValues?.id || isView}
                        shouldNotShowActionTop={initialValues?.id || isView}
                        setInitialValuesFormThemVT={setInitialValuesFormThemVT}
                        setOpenDialog={handleOpenDialogThemMoi}
                        dsItems={dataTable?.[TYPE_KE_HOACH_DAO_TAO.CAN_BO.code] ?? []}
                        type={TYPE_KE_HOACH_DAO_TAO.CAN_BO}
                      />
                      <TableDangKyDaoTao
                        columns={columnsKTChuyenMon}
                        title={"Khả năng đáp ứng cử người hành nghề đi hỗ trợ kỹ thuật chuyên môn"}
                        isView={!initialValues?.id || isView || detailPhieuKeHoach?.status !== STATUS.new_save}
                        shouldNotShowActionTop={!initialValues?.id || isView || detailPhieuKeHoach?.status !== STATUS.new_save}
                        setInitialValuesFormThemVT={setInitialValuesFormThemVT}
                        setOpenDialog={handleOpenDialogThemMoi}
                        dsItems={dataTable?.[TYPE_KE_HOACH_DAO_TAO.KT_CHUYEN_MON.code] ?? []}
                        type={TYPE_KE_HOACH_DAO_TAO.KT_CHUYEN_MON}
                      />
                      <TableDangKyDaoTao
                        columns={columnsNhuCau}
                        title={"Xác nhận đáp ứng"}
                        isView={!initialValues?.id || isView || detailPhieuKeHoach?.status === STATUS.new_save}
                        shouldNotShowActionTop={!initialValues?.id || isView || detailPhieuKeHoach?.status === STATUS.new_save}
                        setInitialValuesFormThemVT={setInitialValuesFormThemVT}
                        setOpenDialog={handleOpenDialogThemMoi}
                        dsItems={dataTable?.[TYPE_KE_HOACH_DAO_TAO.NHU_CAU.code] ?? []}
                        type={TYPE_KE_HOACH_DAO_TAO.NHU_CAU}
                      />
                    </>
                  )}
                </div>
                {/*{type?.formVatTu && <CustomTabMenu*/}
                {/*    danhsachTabs={[*/}
                {/*      {*/}
                {/*        eventKey: "0",*/}
                {/*        title: "Thông tin chung",*/}
                {/*        component: <>*/}
                {/*          <div className="spaces px-10">*/}
                {/*            <GenerateFormComponent*/}
                {/*              isView={isView}*/}
                {/*              listFieldAuto={listJsonGenerate}*/}
                {/*              handleChange={handleChange}*/}
                {/*              setValues={setValues}*/}
                {/*              values={values}*/}
                {/*              touched={touched}*/}
                {/*              errors={errors}*/}
                {/*              propsRenderButton={handler}*/}
                {/*              setFieldValue={setFieldValue}*/}
                {/*              modelID={'khaoSat'}*/}
                {/*              customComponent={DynamicComponent}*/}
                {/*              warehouseId={warehouseId}*/}
                {/*              customFieldReadOnly={fieldReadOnly}*/}
                {/*            />*/}
                {/*            {type.code === CODE_KE_HOACH.KHHT && (*/}
                {/*              <>*/}
                {/*                <TableDangKyDaoTao*/}
                {/*                  columns={columnsCanBo}*/}
                {/*                  title={"Đề xuất cử người hỗ trợ"}*/}
                {/*                  isView={isView}*/}
                {/*                  shouldNotShowActionTop={isView}*/}
                {/*                  setInitialValuesFormThemVT={setInitialValuesFormThemVT}*/}
                {/*                  setOpenDialog={handleOpenDialogThemMoi}*/}
                {/*                  dsItems={dataTable?.[TYPE_KE_HOACH_DAO_TAO.CAN_BO.code] ?? []}*/}
                {/*                  type={TYPE_KE_HOACH_DAO_TAO.CAN_BO}*/}
                {/*                />*/}
                {/*                <TableDangKyDaoTao*/}
                {/*                  columns={columnsKTChuyenMon}*/}
                {/*                  title={"Khả năng đáp ứng cử người hành nghề đi hỗ trợ kỹ thuật chuyên môn"}*/}
                {/*                  isView={isView}*/}
                {/*                  shouldNotShowActionTop={isView}*/}
                {/*                  setInitialValuesFormThemVT={setInitialValuesFormThemVT}*/}
                {/*                  setOpenDialog={handleOpenDialogThemMoi}*/}
                {/*                  dsItems={dataTable?.[TYPE_KE_HOACH_DAO_TAO.KT_CHUYEN_MON.code] ?? []}*/}
                {/*                  type={TYPE_KE_HOACH_DAO_TAO.KT_CHUYEN_MON}*/}
                {/*                />*/}
                {/*                <TableDangKyDaoTao*/}
                {/*                  columns={columnsNhuCau}*/}
                {/*                  title={"Xác nhận đáp ứng"}*/}
                {/*                  isView={isView}*/}
                {/*                  shouldNotShowActionTop={isView}*/}
                {/*                  setInitialValuesFormThemVT={setInitialValuesFormThemVT}*/}
                {/*                  setOpenDialog={handleOpenDialogThemMoi}*/}
                {/*                  dsItems={dataTable?.[TYPE_KE_HOACH_DAO_TAO.NHU_CAU.code] ?? []}*/}
                {/*                  type={TYPE_KE_HOACH_DAO_TAO.NHU_CAU}*/}
                {/*                />*/}
                {/*              </>*/}
                {/*            )}*/}
                {/*          </div>*/}
                {/*        </>,*/}
                {/*      },*/}
                {/*      {*/}
                {/*        eventKey: "1",*/}
                {/*        title: "Tài liệu đính kèm",*/}
                {/*        component: "Tài liệu đính kèm",*/}
                {/*      },*/}
                {/*    ]}*/}
                {/*    className="spaces pl-0"*/}
                {/*/>}*/}
              </Modal.Body>
              <div className="bottom-button d-flex justify-content-start w-100 bg-white spaces py-6 pl-5">
                {!isView && <Button type="submit" className="btn btn-fill min-w-120px spaces mx-3">
                  <IconButtonSave /> Lưu
                </Button>}
                {(values.khaoSat?.id || detailPhieuKeHoach?.id) && !detailPhieuKeHoach?.isView && type?.trackerCode && (
                  <WfButton
                    additionalFunc={(data: any) => {
                      setDetailPhieuKeHoach({
                        ...data,
                        ...detailPhieuKeHoach,
                        status: data?.currCode,
                        statusCode: data?.currCode,
                        statusId: data?.currId,
                      })
                      if ((data?.currCode === "compliance_confirmation" && !data?.firstTime && type?.trackerCode === WF_TRACKER.SURVEY_TECHNIQUE_TRANFER) || data?.currCode === "approved_done") {
                        toast.success('Thành công')
                        onHide()
                      }
                    }}
                    afterSubmit={() => {
                      handleFormSubmit(values)
                    }}
                    handleClick={(data: any) => {
                      data.code === "allowed-edit" && setIsView(false);
                    }}
                    tracker={type?.trackerCode}
                    objectId={values.khaoSat?.id || detailPhieuKeHoach?.id}
                  />
                )}
              </div>
            </Form>

            {openDialogThemMoi && typeDialogAddNew &&
              <DialogThemMoiDaoTao
                onOk={handleAddItem}
                show={openDialogThemMoi}
                onHide={handleCloseDialog}
                initialValues={{
                  [typeDialogAddNew.code]: {
                    ...itemSelected,
                    id: indexRowEdit === null ? null : Math.random().toString(36).substring(0, 10),
                  }
                }}
                type={typeDialogAddNew}
              />
            }
            {
              detailPhieuKeHoach?.componentName === "DialogEnterReason" &&
              <EnterReasonDialog
                labelReason={"Lý do yêu cầu chỉnh sửa"}
                show={detailPhieuKeHoach?.componentName === "DialogEnterReason"}
                title={`Yêu cầu chỉnh sửa`}
                onHide={handleCloseDialog}
                onSubmit={handleApproveReq}
              />
            }
            {
              detailPhieuKeHoach?.componentName === "DialogEnterReason" &&
              <EnterReasonDialog
                labelReason={"Lý do"}
                show={detailPhieuKeHoach?.componentName === "DialogEnterReason"}
                title={`Từ chối`}
                onHide={handleCloseDialog}
                onSubmit={handleApproveReq}
              />
            }
          </>
        )}
      </Formik>
    </Modal>
  );
};

export default DialogPhieuKhaoSat;
